import React from 'react'
import '../Page.css'

const Bookmarks = ()=> {
  return (
    <div className='page'>
        <h2 className='pageTitle'>While we're still in development, please visit Profile for more information</h2>
    </div>
  )
}

export default Bookmarks;